



















import { defineComponent } from '@vue/composition-api'

import { kanaToHira } from '@/utils/kanaToHira'

export default defineComponent({
  name: 'AppAutocomplete',
  props: {
    label: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: '',
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    isNg: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const autoCompleteFilter = (
      item: any,
      queryText: string,
      itemText: string,
    ) => {
      const itemKanaText = kanaToHira(itemText)
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        itemKanaText
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      )
    }
    return { autoCompleteFilter }
  },
})
